import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import BookingForm from "@/components/BookingForm";

export default function BookingDialog({ open, onOpenChange, onCreated }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-2xl" data-testid="create-order-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight text-2xl">New Booking</DialogTitle>
        </DialogHeader>
        <BookingForm onCreated={() => { onOpenChange(false); onCreated?.(); }} />
      </DialogContent>
    </Dialog>
  );
}
